import { useState } from 'react';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { clustersSelector } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/selectors';
import { useGetYandexMapScriptQuery } from '@/packages/query-state/shared/store/yandex-map/2.1/get-yandex-map/query';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';
import { useMapConfigurationSelector } from '@/packages/redux-state/store/slices/mapConfiguration';

export function useGetClustersOnMapOpen(): void {
  const isNarrowListing = useListingLayoutIsNarrowSelector();

  const { isSuccess: isGetMapsScriptSuccess } = useGetYandexMapScriptQuery();
  const { initialized } = useMapConfigurationSelector();

  const [isRequested, setIsRequested] = useState(false);

  useGetClustersQuery({
    enabled: !isRequested && isNarrowListing && isGetMapsScriptSuccess && initialized,
    select: clustersSelector,
    onSuccess: () => setIsRequested(true),
  });
}
